export default {
	id: 'SIMPLE_PAYWALL_1M_29_99_3M_15_00',
	providers: {
		paltaMap: {
			USD: 'simple_premium_comm_1m_29_99_3m_15_usd',
			EUR: 'simple_premium_comm_1m_29_99_3m_15_eur',
			GBP: 'simple_premium_comm_1m_29_99_3m_15_gbp',
			CAD: 'simple_premium_comm_1m_49_99_3m_25_cad',
			AUD: 'simple_premium_comm_1m_49_99_3m_25_aud',
			DKK: 'simple_premium_comm_1m_259_3m_129_dkk',
			SEK: 'simple_premium_comm_1m_399_3m_199_sek',
			NOK: 'simple_premium_comm_1m_399_3m_199_nok',
			BRL: 'simple_premium_comm_1m_199_90_3m_99_90_brl',
			MXN: 'simple_premium_comm_1m_499_3m_249_mxn',
			TRY: 'simple_premium_comm_1m_999_3m_499_try',
			ARS: 'simple_premium_comm_1m_39990_3m_20000_ars',
			COP: 'simple_premium_comm_1m_119990_3m_60000_cop',
			CLP: 'simple_premium_comm_1m_29990_3m_15000_clp',
		},
		primer: 'prd_w1R6kGcShbxj',
	},
	model: {
		commitment_period: 3,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 15,
			EUR: 15,
			GBP: 15,
			CAD: 25,
			AUD: 25,
			DKK: 129,
			SEK: 199,
			NOK: 199,
			BRL: 99.9,
			MXN: 249,
			TRY: 499,
			ARS: 20000,
			COP: 60000,
			CLP: 15000,
		},
		originalPriceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.9,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.90_days.period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
	}),
}
